import axios from "axios";
import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import objectPath from "object-path";
import { LuArrowLeft } from "react-icons/lu";
import { API_ROOT } from "../../defines";
import moment from "moment";
import { PiEye } from "react-icons/pi";
import { IoCalendarOutline } from "react-icons/io5";
import { useTranslation } from "react-i18next";
const Detail = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const [data, setdata] = useState(null);
  const [loading, setloading] = useState(false);
  const navigate = useNavigate();
  useEffect(() => {
    const fetch = async () => {
      setloading(true);
      const result = await axios({
        url: `/service/advice/${id}`,
        method: "GET",
        auth: {
          username: "hsct",
          password:
            "769a9a905bbd4046903581605db75cad20fe84c70868d9874a628f09347c47df",
        },
      });
      console.log("🚀 ~ fetch ~ result:", result.data);

      setdata(objectPath.get(result, "data"));
      setloading(false);
    };
    id && fetch();
    id && addViews();
  }, []);
  const addViews = async () => {
    await axios({
      url: `/service/advice/${id}`,
      method: "PUT",
      auth: {
        username: "hsct",
        password:
          "769a9a905bbd4046903581605db75cad20fe84c70868d9874a628f09347c47df",
      },
    });
  };
  const media = (data) => {
    const file = objectPath.get(data, "file.0");
    const url = API_ROOT + "/" + objectPath.get(file, "id");
    const { type } = file;

    if (type == "image")
      return (
        <img src={url} className="w-32 bg-contain" crossOrigin="anonymous" />
      );
    if (type == "video")
      return (
        <video
          key={url}
          className="w-full"
          controls="controls"
          crossOrigin="anonymous"
        >
          <source src={url}></source>
        </video>
      );

    // if (type == "image") return <video />;
  };
  return (
    <div className="flex flex-col w-full p-8">
      <div className="flex flex-col justify-center items-center w-full">
        {loading ? (
          <div></div>
        ) : (
          data && (
            <div className="flex flex-col w-full md:w-2/3 mb-24 bg-white p-4 rounded-lg shadow-md">
              <div className="flex w-full justify-between items-center">
                <div onClick={() => navigate(-1)}>
                  <LuArrowLeft size={20} color="#1A2E55" />
                </div>
                <div className="text-center w-full text-2xl font-semibold">
                  {objectPath.get(data, "title")}
                </div>
                <div></div>
              </div>
              <div className="flex justify-center w-full mt-4">
                {media(data)}
              </div>
              <div className="flex w-full justify-between border-t-2 border-dark-90 pt-4 mt-4">
                <div className="flex items-center">
                  <IoCalendarOutline color="#6B7280" size={16} />
                  <div className="text-base text-gray-500 mt-0.5 ml-1">
                    {moment(objectPath.get(data, "created")).format(
                      "YYYY-MM-DD"
                    )}
                  </div>
                </div>
                <div className="flex items-center ml-2">
                  <PiEye color="#6B7280" size={16} />
                  <div className="text-base text-gray-500 mt-0.5 ml-1">
                    {objectPath.get(data, "views", 0)}
                  </div>
                </div>
              </div>
              <div className="text-justify mt-4 flex w-full">
                {objectPath.get(data, "description")}
              </div>
              {objectPath.get(data, "link") != undefined && (
                <a
                  target="_blank"
                  href={`${objectPath.get(data, "link")}`}
                  className="underline text-blue-600 my-2 font-medium"
                >
                  {t("advice.click")}
                </a>
              )}
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default Detail;
